import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Sécurité / hygiène : en production, on neutralise la console pour ne pas
// exposer de détails d'implémentation (messages d'erreur internes, noms de
// fonctions, chemins) dans les DevTools. En développement, tout reste visible.
if (!import.meta.env.DEV) {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.warn = noop;
  console.error = noop;
  console.debug = noop;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  const swPath = __BASE_PATH__ + '/sw.js';
  navigator.serviceWorker.register(swPath, {
    scope: __BASE_PATH__ + '/',
  }).then((registration) => {
    if (import.meta.env.DEV) {
      console.log('Service Worker registered:', registration.scope);
    }

    // Enregistrer le Background Sync si supporté
    if ('sync' in registration && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ type: 'REGISTER_SYNC' });
    }

    // Écouter les messages du Service Worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'BACKGROUND_SYNC') {
        // Déclencher la synchronisation dans l'application
        window.dispatchEvent(new CustomEvent('csf-background-sync'));
      }
      if (event.data && event.data.type === 'SW_UPDATED') {
        // Nouvelle version du Service Worker disponible
        const version = event.data.version || 'nouvelle';
        const buildId = event.data.buildId || '';
        console.log(`[SW] Nouvelle version disponible: ${version} (build ${buildId})`);
        
        // Afficher un bandeau discret en haut de la page
        const banner = document.createElement('div');
        banner.id = 'sw-update-banner';
        banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;background:#0d7c6b;color:white;padding:10px 20px;text-align:center;font-family:sans-serif;font-size:14px;display:flex;align-items:center;justify-content:center;gap:12px;';
        banner.innerHTML = `
          <span>🔄 Une nouvelle version de l'application est disponible.</span>
          <button id="sw-update-reload" style="background:white;color:#0d7c6b;border:none;padding:6px 16px;border-radius:6px;font-weight:600;cursor:pointer;font-size:13px;">Recharger maintenant</button>
          <button id="sw-update-dismiss" style="background:transparent;color:white;border:1px solid rgba(255,255,255,0.5);padding:6px 12px;border-radius:6px;cursor:pointer;font-size:13px;">Plus tard</button>
        `;
        document.body.prepend(banner);
        
        document.getElementById('sw-update-reload')?.addEventListener('click', () => {
          window.location.reload();
        });
        document.getElementById('sw-update-dismiss')?.addEventListener('click', () => {
          banner.remove();
        });
      }
    });
  }).catch((err) => {
    if (import.meta.env.DEV) {
      console.warn('Service Worker registration failed:', err);
    }
  });
}